import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import IntroductionPage from "./components/IntroductionPage";
import ServicePage from "./components/ServicePage";
import ContactUsPage from "./components/ContactUsPage";

export default function App() {
  return (
    <Router>
        <Header />
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/gioi-thieu" element={<IntroductionPage />} />
            <Route path="/dich-vu" element={<ServicePage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/dich-vu/:slug" element={<ServicePage />} />
        </Routes>
        <Footer />
    </Router>
  );
}
